
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta } from "/vercel/path0/pages/auth/login.vue?macro=true";
import { default as _91id_934nqUH9EitCZ_45Ef1yJSip3guNqhjsRg6wPUmVPFYiGloMeta } from "/vercel/path0/pages/forms/[id].vue?macro=true";
import { default as _91id_93Tv4NYxvQj4TW8zk_bulx0E39dMt9e_UQ0Sk1p6Cmx_UMeta } from "/vercel/path0/pages/tasks/[id].vue?macro=true";
import { default as google0vudAf2ctSgHNj2dTT9iEr8BZiHBtjOjvZ84837IcBQMeta } from "/vercel/path0/pages/auth/google.vue?macro=true";
import { default as indexMPAusuq6boMUmI9zN8I4N6GXe_453ZCMj85cNIeHdk7oEMeta } from "/vercel/path0/pages/forms/index.vue?macro=true";
import { default as _91id_93C5D8uAKM0PTEDwvVhsP0ZTu4XBwdtCpMAAd40XTyR6EMeta } from "/vercel/path0/pages/people/[id].vue?macro=true";
import { default as indexbew0nVKwsfyGVoxhAN2SO3WGVpn50EmGjMwWLpTQ1uAMeta } from "/vercel/path0/pages/tasks/index.vue?macro=true";
import { default as indexNa_vm9JKC0N_451Lelh8eSfD_FLQ5Khtv0oX5haFw3ChcMeta } from "/vercel/path0/pages/emails/index.vue?macro=true";
import { default as indexvuArMYIMoD2OrLrzQEDazqqCPIddENz2yT___iUpK_AMeta } from "/vercel/path0/pages/people/index.vue?macro=true";
import { default as finalizeo4pOmVVhywCULZC3_dKciU9w1ECCwPof9kb8nho9IHUMeta } from "/vercel/path0/pages/auth/finalize.vue?macro=true";
import { default as registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta } from "/vercel/path0/pages/auth/register.vue?macro=true";
import { default as editGcKt7rniultqUZZBkhONuZM3NAhkpMDIpaIFVuXvWhAMeta } from "/vercel/path0/pages/apps/[id]/edit.vue?macro=true";
import { default as index73QoxocgX_1MGJsjeRTeNRkL1qyw_45eBo4LtwmFCW_45ycMeta } from "/vercel/path0/pages/apps/[id]/index.vue?macro=true";
import { default as _91_91roomId_93_93HkEBVqvRv992l_DEpn7IYg9Tjiqlhw7iLCA75dvJgIwMeta } from "/vercel/path0/pages/inbox/[[roomId]].vue?macro=true";
import { default as indexrEL8rxfs1ogqcD5OQCsdsOGMn5IXhDijcp8LH_PxhKoMeta } from "/vercel/path0/pages/automations/index.vue?macro=true";
import { default as indexfDIB5APMfxdVYzGG_45RjoRKSC5zN2wRBb2S4MEFOLskcMeta } from "/vercel/path0/pages/emails/[id]/index.vue?macro=true";
import { default as _91id_93zudAf5Aa4H6DgBtKZWdQIqXY65f0tPsmjCN0zQaCDKQMeta } from "/vercel/path0/pages/settings/runs/[id].vue?macro=true";
import { default as indexrtnZR3_XWD8dmHKfQyWX1g4fE8LztntFHrPcrSvdJJgMeta } from "/vercel/path0/pages/apps/afas_old/index.vue?macro=true";
import { default as password_45resetZv7veHzMlsXXfhlVMOKOfR67Q_JYmhznEE0D6ncUxekMeta } from "/vercel/path0/pages/auth/password-reset.vue?macro=true";
import { default as previewGHtgNeMu_45fSOKqHseMGmQlrXCleLQefdw7ISnH_uqVcMeta } from "/vercel/path0/pages/emails/[id]/preview.vue?macro=true";
import { default as inboxQTBiSYjyR4ppKqxrNPPdlDlPDssty1wbYEE2Ij8J9_EMeta } from "/vercel/path0/pages/embed/carerix/inbox.vue?macro=true";
import { default as tasksj79KNOZk2soUTGMRECpytEfK_DnczCjdYP3HNX3ZruUMeta } from "/vercel/path0/pages/embed/carerix/tasks.vue?macro=true";
import { default as index4Qi5M_HnkHsmn9wPA_qoTGUJzrfjqdpAMecri9Wx7JQMeta } from "/vercel/path0/pages/settings/apps/index.vue?macro=true";
import { default as profileAjfYevaseMHO3a1QcLyqIKqhMuAVQwBkKrsxb8YwVhkMeta } from "/vercel/path0/pages/settings/me/profile.vue?macro=true";
import { default as index0l_xEDZjXMgLc8B9xyiB1_45xNAdZ2ZEQUX3Imr_p_45_45j4Meta } from "/vercel/path0/pages/settings/runs/index.vue?macro=true";
import { default as _91id_93_45afzHTTeUtfL5UZLMY99JgZ7nEtRwXcgKuc3AMVGqcQMeta } from "/vercel/path0/pages/inbox/responses/[id].vue?macro=true";
import { default as _91_46_46_46id_93kV4d99GlwMFv2NG1CGky_45UaHCJM0Q_KKcDxDlQU5o4oMeta } from "/vercel/path0/pages/public/forms/[...id].vue?macro=true";
import { default as _91id_93wZITia__4508VOzv3eMrq2Hxcw_45G6gCaRvjodUUbitmJ4Meta } from "/vercel/path0/pages/settings/events/[id].vue?macro=true";
import { default as editxnBSxek6NwERE3exLH54fEOIx0ntlf3eOqkZNyr23CAMeta } from "/vercel/path0/pages/automations/[id]/edit.vue?macro=true";
import { default as runsenh49yczdZTuhwfQSjhcNjqsI7DVQVTqrrwVFiwJCQIMeta } from "/vercel/path0/pages/automations/[id]/runs.vue?macro=true";
import { default as indexEZrljAwwXfwR0tClsuCqnnesccesFy_45gn8hV901Dvl0Meta } from "/vercel/path0/pages/inbox/responses/index.vue?macro=true";
import { default as indexxTK7PO_F_oDf81ualT1QbN2PpuiWAFhh6N79bAPgof0Meta } from "/vercel/path0/pages/settings/events/index.vue?macro=true";
import { default as index4bJBVXqQ8kEmweMKz6jz7ZUnEe4sVVxCkdyisKgw2PMMeta } from "/vercel/path0/pages/automations/[id]/index.vue?macro=true";
import { default as tasksoltZRJbfkFsvEUO9hXbJzUARpV9rZkPv6H3Of2Vnn9AMeta } from "/vercel/path0/pages/automations/[id]/tasks.vue?macro=true";
import { default as settingszUGPiDKILtWchRltnhIh7pREdDYtfQDo75ChHlF8BjUMeta } from "/vercel/path0/pages/embed/carerix/settings.vue?macro=true";
import { default as _91_91roomId_93_936OKZt1Mf17mB_45nngX_6nCaex9EzxFfmJiufeLa87Ix8Meta } from "/vercel/path0/pages/inbox/email/[[roomId]].vue?macro=true";
import { default as indexIHXJou1CB5VFP8dSLBGjBq70TSWEWCtO2OVycjAI2HAMeta } from "/vercel/path0/pages/settings/account/index.vue?macro=true";
import { default as usagehRwk4DQf8tiVX418aV4exZp9H3tYfe1P_lIdDDCLw8EMeta } from "/vercel/path0/pages/settings/account/usage.vue?macro=true";
import { default as _91token_93jrv5Sd55Ul8aexmfDkSNN0DIhEm9U62hHJegQAcEabwMeta } from "/vercel/path0/pages/auth/invitation/[token].vue?macro=true";
import { default as eventsMxw4nh6HJ6wruGdLjbfR5YKOs08Q3kYbS9_45rjJrKk6QMeta } from "/vercel/path0/pages/automations/[id]/events.vue?macro=true";
import { default as billingQd88buxFkRfLDhnlLhwpJVy3EIiG_g4_45vkP7kxi0ZzUMeta } from "/vercel/path0/pages/settings/account/billing.vue?macro=true";
import { default as editdV_45iakWyNPZ2H0_45F9MXEOaRunm04VdP22V2xx1tu8K0Meta } from "/vercel/path0/pages/apps/salesforce/[id]/edit.vue?macro=true";
import { default as workflowxRvbY286YEA_9qIjXmxAnSsQmkVc41RNH8AVTAqvkp8Meta } from "/vercel/path0/pages/automations/[id]/workflow.vue?macro=true";
import { default as automationsEQyhk1uEVruGAuHVaIvwJBncNuiGnMZi2Gc0VGnHSZ0Meta } from "/vercel/path0/pages/embed/carerix/automations.vue?macro=true";
import { default as _91_91roomId_93_93iJ3FpGOjjm6JQFUQi862eMHDNUh1JXUqPBqNvKtI0roMeta } from "/vercel/path0/pages/inbox/whatsapp/[[roomId]].vue?macro=true";
import { default as _91token_93ljLNuiEg7Mxt1VLch8xmWQ8C57kP_wU0X4dXsp4I49kMeta } from "/vercel/path0/pages/public/domains/dns/[token].vue?macro=true";
import { default as roommbN_45abaCFxi80lcdaBoz49KI9oUlTPvYmRs_4A6kMF4Meta } from "/vercel/path0/pages/embed/carerix/whatsapp/room.vue?macro=true";
import { default as block_45list6jAEHZ7k37_s8TKwG_45HT1l3LGj7rZRIUqbrCuEEcuTIMeta } from "/vercel/path0/pages/settings/account/block-list.vue?macro=true";
import { default as _91id_93HnOolqesS3SR5RcYyOV9JYUiocKmC38Bur6X_45R3Ezs0Meta } from "/vercel/path0/pages/settings/account/users/[id].vue?macro=true";
import { default as index1sIXztuU9W45PqQtbxYPNQEUv3CM80R718F6ANHIGXYMeta } from "/vercel/path0/pages/embed/carerix/whatsapp/index.vue?macro=true";
import { default as _91id_93V9REnfPV19l39GqQQhmMTTrNO_45jLxY72EFeb7IY2GWMMeta } from "/vercel/path0/pages/settings/account/brands/[id].vue?macro=true";
import { default as index9ozSFaBeo7HXnGMwTbJaao0dVg0uDU6a2A28gF5K_45B8Meta } from "/vercel/path0/pages/settings/account/users/index.vue?macro=true";
import { default as runssom2M4BooBqP4fRKG84slKS4CHOxWLCkmtea9HuQRQMMeta } from "/vercel/path0/pages/apps/[id]/[connectionId]/runs.vue?macro=true";
import { default as indexRQon1MEY3KjDu5f_oYq2QRq49_45ycg4_4512iCXZa890AsMeta } from "/vercel/path0/pages/settings/account/brands/index.vue?macro=true";
import { default as _91id_93nd_g3uZN_45qekElb9NnTJNcXJE0ZG4nKh8bgcXGXkUz8Meta } from "/vercel/path0/pages/settings/account/domains/[id].vue?macro=true";
import { default as localizationgGs3s7Xp5QXIwfLaOywEuRP7U8aX7Jqkp5ypC_45g9ouIMeta } from "/vercel/path0/pages/settings/account/localization.vue?macro=true";
import { default as unsubscribesDU7uoEqpmps9ZnN3pOjfeMKoqdqv4Ha6fsvlzCkgg30Meta } from "/vercel/path0/pages/settings/account/unsubscribes.vue?macro=true";
import { default as indexNLr_45HLqybJjE2Kv2WFZ1qdH_9qzTMdSaM_45yfA7qphVEMeta } from "/vercel/path0/pages/apps/[id]/[connectionId]/index.vue?macro=true";
import { default as tasksIbZPFeBaqdSwjDUQ1mUdGcHoQtpPAs1FSq_ol6Bi9OgMeta } from "/vercel/path0/pages/apps/[id]/[connectionId]/tasks.vue?macro=true";
import { default as index76wobGVueQmo01Gaf75OHiM7q7WDtdKmMpAMdNDOfUAMeta } from "/vercel/path0/pages/settings/account/domains/index.vue?macro=true";
import { default as safety_45limitsc07bcJLf2sGo01vvQjsZfj0wGJIUofZaHBd_XVBSk1sMeta } from "/vercel/path0/pages/settings/account/safety-limits.vue?macro=true";
import { default as eventsfdcGy_m92B13i9PI4ckhxEmw0Oa7xs4ucJxFEakhJt8Meta } from "/vercel/path0/pages/apps/[id]/[connectionId]/events.vue?macro=true";
import { default as _91id_9368ivspKFaINjwbuGvmG1eYJ_3r5fXbnJdLp_45EM2GIdoMeta } from "/vercel/path0/pages/settings/account/locations/[id].vue?macro=true";
import { default as index0z9tdlCzupemWIfKxSMae_X5cz_45naPS31xVDYYRqOwoMeta } from "/vercel/path0/pages/settings/account/locations/index.vue?macro=true";
import { default as _91partner_93pysZ_459wkKRg2dE2_45CkQhuTpnA80oKvH9aseVnFxZ_45pIMeta } from "/vercel/path0/pages/auth/referrals/register/[partner].vue?macro=true";
import { default as _91token_93CysHjroVmKT_45a_45uHu0u7TLrjMr_45E_451jUAAurHDB1o3sMeta } from "/vercel/path0/pages/public/notifications/unsubscribe/[token].vue?macro=true";
import { default as _91channel_93_45FjkJlMkioho5bV66KxZZjEShTnotks46_gBNwgM2PsMeta } from "/vercel/path0/pages/apps/whatsapp/[connection]/channels/[channel].vue?macro=true";
import { default as component_45stubhRC7bSErfKcditLppvS4h7_45N619yJxUvXWniDjm0YKwMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_bette_pl56kyq2wjk75b3rf64ctsdave/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubhRC7bSErfKcditLppvS4h7_45N619yJxUvXWniDjm0YKw } from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@11.10.0_db0@0.3.2_bette_pl56kyq2wjk75b3rf64ctsdave/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "auth-login",
    path: "/login",
    meta: loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "forms-id",
    path: "/forms/:id()",
    component: () => import("/vercel/path0/pages/forms/[id].vue")
  },
  {
    name: "tasks-id",
    path: "/tasks/:id()",
    component: () => import("/vercel/path0/pages/tasks/[id].vue")
  },
  {
    name: "auth-google",
    path: "/auth/google",
    meta: google0vudAf2ctSgHNj2dTT9iEr8BZiHBtjOjvZ84837IcBQMeta || {},
    component: () => import("/vercel/path0/pages/auth/google.vue")
  },
  {
    name: "forms",
    path: "/forms",
    component: () => import("/vercel/path0/pages/forms/index.vue")
  },
  {
    name: "people-id",
    path: "/people/:id()",
    component: () => import("/vercel/path0/pages/people/[id].vue")
  },
  {
    name: "tasks",
    path: "/tasks",
    component: () => import("/vercel/path0/pages/tasks/index.vue")
  },
  {
    name: "emails",
    path: "/emails",
    component: () => import("/vercel/path0/pages/emails/index.vue")
  },
  {
    name: "people",
    path: "/people",
    component: () => import("/vercel/path0/pages/people/index.vue")
  },
  {
    name: "auth-finalize",
    path: "/auth/finalize",
    meta: finalizeo4pOmVVhywCULZC3_dKciU9w1ECCwPof9kb8nho9IHUMeta || {},
    component: () => import("/vercel/path0/pages/auth/finalize.vue")
  },
  {
    name: "auth-register",
    path: "/register",
    meta: registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta || {},
    component: () => import("/vercel/path0/pages/auth/register.vue")
  },
  {
    name: "apps-id-edit",
    path: "/apps/:id()/edit",
    component: () => import("/vercel/path0/pages/apps/[id]/edit.vue")
  },
  {
    name: "apps-id",
    path: "/apps/:id()",
    component: () => import("/vercel/path0/pages/apps/[id]/index.vue")
  },
  {
    name: "inbox-roomId",
    path: "/inbox/:roomId?",
    meta: _91_91roomId_93_93HkEBVqvRv992l_DEpn7IYg9Tjiqlhw7iLCA75dvJgIwMeta || {},
    component: () => import("/vercel/path0/pages/inbox/[[roomId]].vue")
  },
  {
    name: "automations",
    path: "/automations",
    component: () => import("/vercel/path0/pages/automations/index.vue")
  },
  {
    name: "emails-id",
    path: "/emails/:id()",
    component: () => import("/vercel/path0/pages/emails/[id]/index.vue")
  },
  {
    name: "settings-runs-id",
    path: "/settings/runs/:id()",
    component: () => import("/vercel/path0/pages/settings/runs/[id].vue")
  },
  {
    name: "apps-afas_old",
    path: "/apps/afas_old",
    component: () => import("/vercel/path0/pages/apps/afas_old/index.vue")
  },
  {
    name: "auth-password-reset",
    path: "/password/reset",
    meta: password_45resetZv7veHzMlsXXfhlVMOKOfR67Q_JYmhznEE0D6ncUxekMeta || {},
    component: () => import("/vercel/path0/pages/auth/password-reset.vue")
  },
  {
    name: "emails-id-preview",
    path: "/emails/:id()/preview",
    component: () => import("/vercel/path0/pages/emails/[id]/preview.vue")
  },
  {
    name: "embed-carerix-inbox",
    path: "/embed/carerix/inbox",
    meta: inboxQTBiSYjyR4ppKqxrNPPdlDlPDssty1wbYEE2Ij8J9_EMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/inbox.vue")
  },
  {
    name: "embed-carerix-tasks",
    path: "/embed/carerix/tasks",
    meta: tasksj79KNOZk2soUTGMRECpytEfK_DnczCjdYP3HNX3ZruUMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/tasks.vue")
  },
  {
    name: "settings-apps",
    path: "/settings/apps",
    component: () => import("/vercel/path0/pages/settings/apps/index.vue")
  },
  {
    name: "settings-me-profile",
    path: "/settings/me/profile",
    component: () => import("/vercel/path0/pages/settings/me/profile.vue")
  },
  {
    name: "settings-runs",
    path: "/settings/runs",
    component: () => import("/vercel/path0/pages/settings/runs/index.vue")
  },
  {
    name: "inbox-responses-id",
    path: "/inbox/responses/:id()",
    component: () => import("/vercel/path0/pages/inbox/responses/[id].vue")
  },
  {
    name: "public-forms-id",
    path: "/public/forms/:id(.*)*",
    meta: _91_46_46_46id_93kV4d99GlwMFv2NG1CGky_45UaHCJM0Q_KKcDxDlQU5o4oMeta || {},
    component: () => import("/vercel/path0/pages/public/forms/[...id].vue")
  },
  {
    name: "settings-events-id",
    path: "/settings/events/:id()",
    component: () => import("/vercel/path0/pages/settings/events/[id].vue")
  },
  {
    name: "automations-id-edit",
    path: "/automations/:id()/edit",
    component: () => import("/vercel/path0/pages/automations/[id]/edit.vue")
  },
  {
    name: "automations-id-runs",
    path: "/automations/:id()/runs",
    component: () => import("/vercel/path0/pages/automations/[id]/runs.vue")
  },
  {
    name: "inbox-responses",
    path: "/inbox/responses",
    component: () => import("/vercel/path0/pages/inbox/responses/index.vue")
  },
  {
    name: "settings-events",
    path: "/settings/events",
    component: () => import("/vercel/path0/pages/settings/events/index.vue")
  },
  {
    name: "automations-id",
    path: "/automations/:id()",
    component: () => import("/vercel/path0/pages/automations/[id]/index.vue")
  },
  {
    name: "automations-id-tasks",
    path: "/automations/:id()/tasks",
    component: () => import("/vercel/path0/pages/automations/[id]/tasks.vue")
  },
  {
    name: "embed-carerix-settings",
    path: "/embed/carerix/settings",
    meta: settingszUGPiDKILtWchRltnhIh7pREdDYtfQDo75ChHlF8BjUMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/settings.vue")
  },
  {
    name: "inbox-email-roomId",
    path: "/inbox/email/:roomId?",
    component: () => import("/vercel/path0/pages/inbox/email/[[roomId]].vue")
  },
  {
    name: "settings-account",
    path: "/settings/account",
    component: () => import("/vercel/path0/pages/settings/account/index.vue")
  },
  {
    name: "settings-account-usage",
    path: "/settings/account/usage",
    component: () => import("/vercel/path0/pages/settings/account/usage.vue")
  },
  {
    name: "auth-invitation-token",
    path: "/invitation/:token",
    meta: _91token_93jrv5Sd55Ul8aexmfDkSNN0DIhEm9U62hHJegQAcEabwMeta || {},
    component: () => import("/vercel/path0/pages/auth/invitation/[token].vue")
  },
  {
    name: "automations-id-events",
    path: "/automations/:id()/events",
    component: () => import("/vercel/path0/pages/automations/[id]/events.vue")
  },
  {
    name: "settings-account-billing",
    path: "/settings/account/billing",
    component: () => import("/vercel/path0/pages/settings/account/billing.vue")
  },
  {
    name: "apps-salesforce-id-edit",
    path: "/apps/salesforce/:id()/edit",
    component: () => import("/vercel/path0/pages/apps/salesforce/[id]/edit.vue")
  },
  {
    name: "automations-id-workflow",
    path: "/automations/:id()/workflow",
    meta: workflowxRvbY286YEA_9qIjXmxAnSsQmkVc41RNH8AVTAqvkp8Meta || {},
    component: () => import("/vercel/path0/pages/automations/[id]/workflow.vue")
  },
  {
    name: "embed-carerix-automations",
    path: "/embed/carerix/automations",
    meta: automationsEQyhk1uEVruGAuHVaIvwJBncNuiGnMZi2Gc0VGnHSZ0Meta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/automations.vue")
  },
  {
    name: "inbox-whatsapp-roomId",
    path: "/inbox/whatsapp/:roomId?",
    component: () => import("/vercel/path0/pages/inbox/whatsapp/[[roomId]].vue")
  },
  {
    name: "public-domains-dns-token",
    path: "/public/domains/dns/:token()",
    meta: _91token_93ljLNuiEg7Mxt1VLch8xmWQ8C57kP_wU0X4dXsp4I49kMeta || {},
    component: () => import("/vercel/path0/pages/public/domains/dns/[token].vue")
  },
  {
    name: "embed-carerix-whatsapp-room",
    path: "/embed/carerix/whatsapp/room",
    meta: roommbN_45abaCFxi80lcdaBoz49KI9oUlTPvYmRs_4A6kMF4Meta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/whatsapp/room.vue")
  },
  {
    name: "settings-account-block-list",
    path: "/settings/account/block-list",
    component: () => import("/vercel/path0/pages/settings/account/block-list.vue")
  },
  {
    name: "settings-account-users-id",
    path: "/settings/account/users/:id()",
    component: () => import("/vercel/path0/pages/settings/account/users/[id].vue")
  },
  {
    name: "embed-carerix-whatsapp",
    path: "/embed/carerix/whatsapp",
    meta: index1sIXztuU9W45PqQtbxYPNQEUv3CM80R718F6ANHIGXYMeta || {},
    component: () => import("/vercel/path0/pages/embed/carerix/whatsapp/index.vue")
  },
  {
    name: "settings-account-brands-id",
    path: "/settings/account/brands/:id()",
    component: () => import("/vercel/path0/pages/settings/account/brands/[id].vue")
  },
  {
    name: "settings-account-users",
    path: "/settings/account/users",
    component: () => import("/vercel/path0/pages/settings/account/users/index.vue")
  },
  {
    name: "apps-id-connectionId-runs",
    path: "/apps/:id()/:connectionId()/runs",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/runs.vue")
  },
  {
    name: "settings-account-brands",
    path: "/settings/account/brands",
    component: () => import("/vercel/path0/pages/settings/account/brands/index.vue")
  },
  {
    name: "settings-account-domains-id",
    path: "/settings/account/domains/:id()",
    component: () => import("/vercel/path0/pages/settings/account/domains/[id].vue")
  },
  {
    name: "settings-account-localization",
    path: "/settings/account/localization",
    component: () => import("/vercel/path0/pages/settings/account/localization.vue")
  },
  {
    name: "settings-account-unsubscribes",
    path: "/settings/account/unsubscribes",
    component: () => import("/vercel/path0/pages/settings/account/unsubscribes.vue")
  },
  {
    name: "apps-id-connectionId",
    path: "/apps/:id()/:connectionId()",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/index.vue")
  },
  {
    name: "apps-id-connectionId-tasks",
    path: "/apps/:id()/:connectionId()/tasks",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/tasks.vue")
  },
  {
    name: "settings-account-domains",
    path: "/settings/account/domains",
    component: () => import("/vercel/path0/pages/settings/account/domains/index.vue")
  },
  {
    name: "settings-account-safety-limits",
    path: "/settings/account/safety-limits",
    component: () => import("/vercel/path0/pages/settings/account/safety-limits.vue")
  },
  {
    name: "apps-id-connectionId-events",
    path: "/apps/:id()/:connectionId()/events",
    component: () => import("/vercel/path0/pages/apps/[id]/[connectionId]/events.vue")
  },
  {
    name: "settings-account-locations-id",
    path: "/settings/account/locations/:id()",
    component: () => import("/vercel/path0/pages/settings/account/locations/[id].vue")
  },
  {
    name: "settings-account-locations",
    path: "/settings/account/locations",
    component: () => import("/vercel/path0/pages/settings/account/locations/index.vue")
  },
  {
    name: "auth-referrals-register-partner",
    path: "/register/:partner",
    meta: _91partner_93pysZ_459wkKRg2dE2_45CkQhuTpnA80oKvH9aseVnFxZ_45pIMeta || {},
    component: () => import("/vercel/path0/pages/auth/referrals/register/[partner].vue")
  },
  {
    name: "public-notifications-unsubscribe-token",
    path: "/public/notifications/unsubscribe/:token()",
    meta: _91token_93CysHjroVmKT_45a_45uHu0u7TLrjMr_45E_451jUAAurHDB1o3sMeta || {},
    component: () => import("/vercel/path0/pages/public/notifications/unsubscribe/[token].vue")
  },
  {
    name: "apps-whatsapp-connection-channels-channel",
    path: "/apps/whatsapp/:connection()/channels/:channel()",
    component: () => import("/vercel/path0/pages/apps/whatsapp/[connection]/channels/[channel].vue")
  },
  {
    name: component_45stubhRC7bSErfKcditLppvS4h7_45N619yJxUvXWniDjm0YKwMeta?.name,
    path: "/auth/register/:pathMatch(.*)",
    component: component_45stubhRC7bSErfKcditLppvS4h7_45N619yJxUvXWniDjm0YKw
  },
  {
    name: component_45stubhRC7bSErfKcditLppvS4h7_45N619yJxUvXWniDjm0YKwMeta?.name,
    path: "/auth/invitation/:pathMatch(.*)",
    component: component_45stubhRC7bSErfKcditLppvS4h7_45N619yJxUvXWniDjm0YKw
  }
]